<template>
  <div v-show="srcoll_flag_state" class="back-card" @click="backTop">
    <img :src="defaultSrc" alt="logo" />
  </div>
</template>

<script>
  import MixinSrcoll from '@/mixins/detail/mixinSrcoll'
  const _mixinSrcoll = new MixinSrcoll()
  export default {
    name: 'ScrollTopCard', // pc端游戏详情页
    mixins: [_mixinSrcoll],
    data() {
      return {
        defaultSrc: require(`@/assets/images/detail/common/goTop.png`),
      }
    },
    methods: {
      backTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    .back-card {
      height: 44px;
      width: 44px;
      position: absolute;
      bottom: -120px;
      right: 20px;
      cursor: pointer;
      &.small900-card {
        display: none;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  @media (max-width: 900px) {
    .back-card {
      &.small900-card {
        display: block;
        position: fixed;
        bottom: 170px;
      }
    }
  }
</style>
